module.exports = __webpack_public_path__ + "static/img/Tate-Delmenico.424d580.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tate-Delmenico.jpg
// module id = 6Gxe
// module chunks = 0